import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "path", "children"];
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import usePrefersReducedMotion from 'hooks/usePrefersReducedMotion';
import useRandomInterval, { random } from 'hooks/useRandomInterval';
import { getRandomNumber } from 'utils/ui';
import Box from 'components/Box';
import Sparkle from './Sparkle';
/* DEFAULTS */

var FALLBACK_COLOR = '#FFC700';
var DEFAULT_SPARKLE_SVG_PATH = 'M26.5 25.5C19.0043 33.3697 0 34 0 34C0 34 19.1013 35.3684 26.5 43.5C33.234 50.901 34 68 34 68C34 68 36.9884 50.7065 44.5 43.5C51.6431 36.647 68 34 68 34C68 34 51.6947 32.0939 44.5 25.5C36.5605 18.2235 34 0 34 0C34 0 33.6591 17.9837 26.5 25.5Z';

/* UTILS */

var generateSparkle = function generateSparkle(color) {
  var sparkle = {
    id: String(random(10000, 99999)),
    createdAt: Date.now(),
    color: color,
    size: random(10, 20),
    style: {
      top: "".concat(random(0, 100), "%"),
      left: "".concat(random(0, 100), "%"),
      zIndex: random(-2, 10)
    }
  };
  return sparkle;
};
var Sparkles = function Sparkles(_ref) {
  var setColor = _ref.color,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? DEFAULT_SPARKLE_SVG_PATH : _ref$path,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var color = setColor || theme.globals.colorBlocks.sparkles || FALLBACK_COLOR;
  var _useState = useState(function () {
      return getRandomNumber(3).map(function () {
        return generateSparkle(color);
      });
    }),
    _useState2 = _slicedToArray(_useState, 2),
    sparkles = _useState2[0],
    setSparkles = _useState2[1];

  // Turns of sparkle animation for increased accessibility
  var prefersReducedMotion = usePrefersReducedMotion();
  useRandomInterval(function () {
    // Create a new sparkle
    var sparkle = generateSparkle(color);
    var now = Date.now();

    // Clean up any "expired" sparkles
    var nextSparkles = sparkles.filter(function (sp) {
      var delta = now - sp.createdAt;
      return delta < 750;
    });
    // Include our new sparkle
    nextSparkles.push(sparkle);
    setSparkles(nextSparkles);
  }, prefersReducedMotion ? null : 100, prefersReducedMotion ? null : 850);
  return /*#__PURE__*/React.createElement(Box, _extends({
    z: 5,
    display: "inline-block",
    position: "relative"
  }, otherProps), sparkles.map(function (sparkle) {
    return /*#__PURE__*/React.createElement(Sparkle, {
      key: sparkle.id,
      path: path,
      color: sparkle.color,
      size: sparkle.size,
      style: sparkle.style
    });
  }), children);
};
export default Sparkles;